module.exports = __webpack_public_path__ + "img/ic-m-file-upload.9621dae2.svg";